import { Action, createReducer, on } from '@ngrx/store';
import {
  addLoyaltyCardsAction,
  addLoyaltyCardsErrorAction,
  addLoyaltyCardsSuccessAction,
  deleteLoyaltyCardAction,
  deleteLoyaltyCardErrorAction,
  deleteLoyaltyCardSuccessAction,
  getAppleWalletPassAction,
  getAppleWalletPassErrorAction,
  getAppleWalletPassSuccessAction,
  getGoogleWalletPassAction,
  getGoogleWalletPassErrorAction,
  getGoogleWalletPassSuccessAction,
  loadLoyaltyCardsAction,
  loadLoyaltyCardsErrorAction,
  loadLoyaltyCardsSuccessAction,
} from './loyalty-cards.actions';
import { LoyaltyCardsState } from './loyalty-cards.state';

const initialState = new LoyaltyCardsState();

const reducer = createReducer(
  initialState,
  on(loadLoyaltyCardsAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(loadLoyaltyCardsSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.loyaltyCards = payload.loyaltyCards;
    return newState;
  }),
  on(loadLoyaltyCardsErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),

  on(addLoyaltyCardsAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(addLoyaltyCardsSuccessAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    // newState.loyaltyCards = payload.loyaltyCards;
    return newState;
  }),
  on(addLoyaltyCardsErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(deleteLoyaltyCardAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(deleteLoyaltyCardSuccessAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    // newState.deletedLoyaltySuccess = {success: true};
    return newState;
  }),
  on(deleteLoyaltyCardErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(getGoogleWalletPassAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getGoogleWalletPassSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.getGoogleWalletPass = payload.getGoogleWalletPass;
    return newState;
  }),
  on(getGoogleWalletPassErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(getAppleWalletPassAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getAppleWalletPassSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.appleWalletPass = payload.appleWalletPass;
    return newState;
  }),
  on(getAppleWalletPassErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  })
);

export function LoyaltyCardsReducer(state: LoyaltyCardsState | undefined, action: Action) {
  return reducer(state, action);
}
